import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=caac37c4&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caac37c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caac37c4')) {
      api.createRecord('caac37c4', component.options)
    } else {
      api.reload('caac37c4', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=caac37c4&scoped=true", function () {
      api.rerender('caac37c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/operations/inStock/Index.vue"
export default component.exports